/*eslint-disable*/
import { FC, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core';
import EyeIcon from 'src/icons/Eye';
import useAuth from '../../../hooks/useAuth';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import { useStyles } from '../../../pages/authentication/style';
import { useSnackbar } from 'notistack';
import Cookies from 'js-cookie';


interface LoginJWTProps {
  provider: (val: boolean) => void;
  [key: string]: any;
}

const LoginJWT: FC<LoginJWTProps> = ({ provider, ...props }) => {
  const isMountedRef = useIsMountedRef();
  const { enqueueSnackbar } = useSnackbar();
  const { login, loginProvEmail, loginProvEmailToken } = useAuth() as any;
  const { t } = useTranslation('account');
  const classes = useStyles();
  const [isProvider, setIsProvider] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [isProviderEmail, setIsProviderEmail] = useState(false);
  const [radioValue, setRadioValue] = useState('provider');
  const [isTokenizedLogin, setIsTokenizedLogin] = useState(false);
  const [urlValues, setUrlValues] = useState({ curRuc: '' });

  const handleProvider = () => {
    setIsProvider(!isProvider);
    provider(!isProvider);
  };

  const handleProvider2 = (event) => {
    setRadioValue(event.target.value);
  };

  const togglePasswordVisiblity = () => {
    setPasswordShown(!passwordShown);
  };

  const getQueryParams = (search) => {
    const params = new URLSearchParams(search);
    const queryParams = {};
    for (let [key, value] of params.entries()) {
      queryParams[key] = value;
    }
    return queryParams;
  };

  useEffect(() => {
    const performLogin = async () => {
      localStorage.clear();
      // New process login via email > JUL 2024
      const urlTmp = location.search;
      const parsedParams: any = getQueryParams(urlTmp);
      if (parsedParams?.curRuc) {
        setIsProviderEmail(true);
        setUrlValues(parsedParams);
      }
      if (parsedParams?.token) {
        setIsTokenizedLogin(true);
        setTimeout(async () => {
          console.log("Ejecutando Login");
          await loginProvEmailToken(parsedParams.curRuc, parsedParams.token);
        }, 3000);
      }

      if (parsedParams?.valueRequested) {
        localStorage.setItem('valueModal', parsedParams.valueRequested);
        if (parsedParams?.busId) {
          localStorage.setItem('busId', parsedParams.busId);
          if (parsedParams?.life) {
            const futureDate = new Date();
            futureDate.setHours(futureDate.getHours() + 12);
            Cookies.set('lifeCOM', parsedParams.life, { expires: futureDate });
            localStorage.setItem('lifeCOM', parsedParams.life);
          }
        }
      } else if (parsedParams?.valueProvider) {
        localStorage.setItem('valueProvider', parsedParams.valueProvider);
        if (parsedParams?.ruc) {
          localStorage.setItem('rucNewProcess', parsedParams.ruc);
        }
      }
    };

    performLogin();
  }, []);

  useEffect(() => {
    const currentUrl = window.location.href;
    if (currentUrl.includes('automaticTrade')) {
      const queryString = window.location.search;

      const urlParams = new URLSearchParams(queryString);
      const encodedDetails = urlParams.get('details');
      const tempTrade = encodedDetails;
      //Improving automatic trade Mrjleo1989
      const futureDate = new Date();
      futureDate.setHours(futureDate.getHours() + 12); // 12 hours from now
      Cookies.set('tradeAutomatico', tempTrade, { expires: futureDate });
      //Expiring notif AT
      const life = urlParams.get('life');
      Cookies.set('lifeAT', life, { expires: futureDate });
    }
  }, [])

  return (
    isTokenizedLogin ?
      <p>Haciendo Login seguro..!!</p>
      :
      isProviderEmail ?
        <Formik
          enableReinitialize
          initialValues={{ email: '', ruc: urlValues.curRuc, submit: null }}
          validationSchema={Yup.object().shape({
            email: Yup.string().when('ruc', {
              is: (ruc) => !ruc || ruc.length === 0,
              then: Yup.string()
                .email(t('validation.validEmail'))
                .max(255)
                .required(t('validation.fieldRequired'))
            }),
            ruc: urlValues.curRuc ? Yup.string() : Yup.string().when('email', {
              is: (email) => !email || email.length === 0,
              then: Yup.string().required(t('validation.fieldRequired')),
            })
          }, [['email', 'ruc']])}
          onSubmit={async (
            values,
            { setErrors, setStatus, setSubmitting }
          ): Promise<void> => {
            try {
              console.log(values.ruc)
              console.log(values.email)
              let respLink = await loginProvEmail(values.ruc, values.email);

              enqueueSnackbar(respLink, {
                anchorOrigin: {
                  horizontal: 'right',
                  vertical: 'top',
                },
                variant: 'success',
              });

              if (isMountedRef.current) {
                setStatus({ success: true });
                setSubmitting(false);
              }
            } catch (err) {
              console.error(err);
              if (isMountedRef.current) {
                setStatus({ success: false });
                setErrors({ submit: err.message });
                setSubmitting(false);
              }
            }
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
          }): JSX.Element => (
            <form noValidate onSubmit={handleSubmit} {...props}>
              <FormControl
                sx={{ display: 'flex', alignItems: 'center' }}
                component="fieldset"
              >
                <RadioGroup
                  row
                  aria-label="role"
                  name="radio-buttons-group2"
                  value={radioValue}
                  onChange={handleProvider2}
                >
                  <FormControlLabel
                    value="provider"
                    control={<Radio color="primary" />}
                    sx={{ color: '#42526E' }}
                    label="Soy una empresa"
                  />
                  <FormControlLabel
                    value="client"
                    control={<Radio color="primary" />}
                    sx={{ color: '#42526E' }}
                    label="Soy un proveedor"
                    disabled={true}
                  />
                </RadioGroup>
              </FormControl>

              <TextField
                autoFocus
                error={Boolean(touched.ruc && errors.ruc)}
                fullWidth
                helperText={touched.ruc && errors.ruc}
                label="RUC"
                margin="normal"
                name="ruc"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.ruc}
                variant="outlined"
              />
              <TextField
                autoFocus
                error={Boolean(touched.email && errors.email)}
                fullWidth
                helperText={touched.email && errors.email}
                label={t('login.email')}
                margin="normal"
                name="email"
                onBlur={handleBlur}
                onChange={handleChange}
                type="email"
                value={values.email}
                variant="outlined"
              />

              {errors.submit && (
                <Box sx={{ mt: 3 }}>
                  <FormHelperText error>{errors.submit}</FormHelperText>
                </Box>
              )}
              <Box sx={{ mt: 2 }}>
                <Button
                  className={classes.button}
                  disabled={isSubmitting || values.email == '' || values.ruc == ''}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Enviar Link
                </Button>
              </Box>
            </form>
          )}
        </Formik> :
        <Formik
          initialValues={{
            email: '',
            password: '',
            ruc: '',
            submit: null,
          }}
          validationSchema={Yup.object().shape(
            {
              email: Yup.string().when('ruc', {
                is: (ruc) => !ruc || ruc.length === 0,
                then: Yup.string()
                  .email(t('validation.validEmail'))
                  .max(255)
                  .required(t('validation.fieldRequired')),
              }),
              ruc: Yup.string().when('email', {
                is: (email) => !email || email.length === 0,
                then: Yup.string().required(t('validation.fieldRequired')),
              }),
              password: Yup.string()
                .max(255)
                .required(t('validation.fieldRequired')),
            },
            [['email', 'ruc']]
          )}
          onSubmit={async (
            values,
            { setErrors, setStatus, setSubmitting }
          ): Promise<void> => {
            try {
              if (isProvider === true) {
                await login(values.ruc, values.password, isProvider);
              } else {
                await login(values.email, values.password);
              }

              if (isMountedRef.current) {
                setStatus({ success: true });
                setSubmitting(false);
              }
            } catch (err) {
              console.error(err);
              if (isMountedRef.current) {
                setStatus({ success: false });
                setErrors({ submit: err.message });
                setSubmitting(false);
              }
            }
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
          }): JSX.Element => (
            <form noValidate onSubmit={handleSubmit} {...props}>
              <FormControl
                sx={{ display: 'flex', alignItems: 'center' }}
                component="fieldset"
              >
                <RadioGroup
                  row
                  aria-label="role"
                  defaultValue="client"
                  name="radio-buttons-group"
                  onChange={handleProvider}
                >
                  <FormControlLabel
                    value="client"
                    control={<Radio color="primary" />}
                    sx={{ color: '#42526E' }}
                    label={t('login.enterprise')}
                  />
                  <FormControlLabel
                    value="provider"
                    control={<Radio color="primary" />}
                    sx={{ color: '#42526E' }}
                    label={t('login.provider')}
                  />
                </RadioGroup>
              </FormControl>
              {isProvider === false ? (
                <TextField
                  autoFocus
                  error={Boolean(touched.email && errors.email)}
                  fullWidth
                  helperText={touched.email && errors.email}
                  label={t('login.email')}
                  margin="normal"
                  name="email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="email"
                  value={values.email}
                  variant="outlined"
                />
              ) : (
                <TextField
                  autoFocus
                  error={Boolean(touched.ruc && errors.ruc)}
                  fullWidth
                  helperText={touched.ruc && errors.ruc}
                  label="RUC"
                  margin="normal"
                  name="ruc"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.ruc}
                  variant="outlined"
                />
              )}
              <TextField
                error={Boolean(touched.password && errors.password)}
                fullWidth
                helperText={touched.password && errors.password}
                label={t('form.password')}
                margin="normal"
                name="password"
                onBlur={handleBlur}
                onChange={handleChange}
                type={passwordShown ? 'text' : 'password'}
                value={values.password}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={togglePasswordVisiblity}>
                        <EyeIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              {errors.submit && (
                <Box sx={{ mt: 3 }}>
                  <FormHelperText error>{errors.submit}</FormHelperText>
                </Box>
              )}
              <Box sx={{ mt: 2 }}>
                <Button
                  className={classes.button}
                  disabled={
                    isSubmitting ||
                    (isProvider == false && values.email == '') ||
                    values.password == '' ||
                    (isProvider == true && values.ruc == '') ||
                    values.password == ''
                  }
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  {t('login.login')}
                </Button>
              </Box>
            </form>
          )}
        </Formik>
  );
};

export default LoginJWT;
